import script from "./Preview.vue?vue&type=script&setup=true&lang=js"
export * from "./Preview.vue?vue&type=script&setup=true&lang=js"

import "./Preview.vue?vue&type=style&index=0&id=1bd7f63e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1bd7f63e"]])

export default __exports__